export var poller = function (interval, fn) {
    var timerId;
    var run = function () {
        var repeater = function () {
            // @ts-expect-error
            timerId = setTimeout(run, interval);
        };
        fn(repeater);
    };
    run();
    return {
        cancel: function () { return clearTimeout(timerId); },
    };
};
export var instantPoller = function (_, fn) {
    return poller(0, fn);
};
//# sourceMappingURL=poller.js.map